/** Canonical vertical ids for autonomous trading UI (matches backend `VerticalId`). */
export const TRADE_VERTICAL_IDS = ['stocks'] as const;
export type TradeVerticalId = (typeof TRADE_VERTICAL_IDS)[number];

export const EQUITIES_ONLY_VERTICAL_IDS: readonly TradeVerticalId[] = ['stocks'];

export const TRADE_VERTICAL_LABELS: Record<TradeVerticalId, string> = {
  stocks: 'Stocks',
};

export function isTradeVerticalId(id: string | undefined): id is TradeVerticalId {
  return !!id && (TRADE_VERTICAL_IDS as readonly string[]).includes(id);
}

/** Verticals shown in nav when backend reports equities-only mode. */
export function activeTradeVerticalIds(equitiesOnly: boolean): readonly TradeVerticalId[] {
  return EQUITIES_ONLY_VERTICAL_IDS;
}
